module.exports = __webpack_public_path__ + "05_mid_black.3ee24c02.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/05_mid_black.png
// module id = L8YI
// module chunks = 0